var module = angular.module('akimboApp.controllers', ['ivpusic.cookie', 'ngIdle']);

module.controller('cardActivateCtrl', ['$scope', '$state', 'baseURI', '$http', 'Transform', '$window', '$timeout', function($scope, $state, baseURI, $http, Transform, $window, $timeout){
  $scope.submitted = false;

  $scope.attemptSubmission = function(activateForm){
    if(activateForm.$valid && $scope.formData.pin1 == $scope.formData.pin2){
      activateCard();
    } else {
      $scope.submitted = true;
    }
  };

  var activateCard = function(){
    var activateRequest = {
      _key: $scope.brand.api_key,
      CardNumber: $scope.formData.cardNumber,
      ExpDate: $scope.formData.exp,
      Cvv: $scope.formData.cvv,
      Pin: $scope.formData.pin1
    };

    $http({
      url: baseURI + 'gift-card/activate',
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(activateRequest)
    }).then(function(resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        if(data.Data.IsRegistered === 'true' || data.Data.isRegistered === true){
          $state.go('root.activate.successLogin');
        } else {
          $state.go('root.activate.successRegister');
        }
      } else {
        $window.scrollTo(0,0);
        if(data.ErrorCode == '181'){
          $scope.alertError.show = true;
          $scope.alertError.login = true;
        } else {
          $scope.alertError.show = true;
          $scope.alertError.message = 'Sorry, we were unable to activate your card at this time. Please try again later.';
        }
      }
    }).catch(function(error){
      $window.scrollTo(0,0);
      $scope.alertError.show = true;
      $scope.alertError.message = 'Sorry, we were unable to activate your card at this time. Please try again later.';
    });
  };

}]);
